import React, { useContext, useEffect, useLayoutEffect } from "react";
import { matchPath, useLocation } from "react-router";
import { gql } from "@apollo/client";
import QueryString from "query-string";

import {
  teamRoute,
  shareRoute,
  DESKTOP_BUILD,
  companyRegisterRoute,
} from "helpers";
import { useData, useHistory } from "hooks";
import { authContext } from "contexts";
import Login from "views/login/Login";
import SelectTeamDialog from "dialogs/SelectTeamDialog";
import Viewport from "views/viewport/Viewport";
import CanvasView from "views/canvas/CanvasView";
import ShareView from "views/shares/ShareView";
import DesktopView from "views/desktop/DesktopView";
import SupportView from "views/support/SupportView";
import CompanyRegisterView from "./register/CompanyRegisterView";
import SetPassword from "./login/SetPassword";
import RoutesSwitch from "providers/RoutesSwitch";

const loginRoute = {
  path: "/login",
};

const setPasswordRoute = {
  path: "/set-password",
};

const selectTeamRoute = {
  path: "/",
};

const canvasRoute = {
  path: "/canvas",
};

const supportRoute = {
  path: "/support",
};

export default function MainView() {
  const location = useLocation();
  const history = useHistory();
  const { authenticated } = useContext(authContext);

  const [
    //
    isRootPath,
    isSetPasswordPath,
    isLoginPath,
    isTeamPath,
    isCanvasPath,
    isSupportPath,
  ] = [
    ["/", true],
    ["/set-password", true],
    ["/login", false],
    ["/T:partialTeamId", false],
    ["/canvas", false],
    ["/support", false],
  ].map(([path, end]) => !!matchPath({ path, end }, location.pathname));

  const isAuthOnlyPath =
    isRootPath ||
    isTeamPath ||
    isCanvasPath ||
    isSupportPath ||
    isSetPasswordPath;

  let shouldSwitchTo = null;

  const query = QueryString.parse(location.search.replace(/^\?/, ""));
  if (isLoginPath && authenticated) {
    if (window._requireResetPassword) {
      shouldSwitchTo = "/set-password";
      window._requireResetPassword = false;
    } else {
      shouldSwitchTo = query.loginRedirect || "/";
    }
  }
  if (isAuthOnlyPath && !authenticated)
    shouldSwitchTo = `/login?${QueryString.stringify({
      loginRedirect: `${location.pathname}${location.search}`,
    })}`;

  useEffect(() => {
    if (shouldSwitchTo) history.replace(shouldSwitchTo);
  }, [shouldSwitchTo]);

  if (shouldSwitchTo) return null;

  if (DESKTOP_BUILD)
    return (
      <>
        <RoutesSwitch
          rules={[
            { route: loginRoute, Component: Login },
            { route: setPasswordRoute, Component: SetPassword },
            { route: selectTeamRoute, exact: true, Component: SelectTeam },
            { route: teamRoute, Component: DesktopView },
          ]}
        />
      </>
    );

  return (
    <>
      <RoutesSwitch
        rules={[
          { route: loginRoute, Component: Login },
          { route: setPasswordRoute, Component: SetPassword },
          { route: selectTeamRoute, exact: true, Component: SelectTeam },
          { route: teamRoute, Component: Viewport },
          { route: canvasRoute, Component: CanvasView },
          { route: supportRoute, Component: SupportView },
          { route: shareRoute, Component: ShareView },
          { route: companyRegisterRoute, Component: CompanyRegisterView },
        ]}
      />
    </>
  );
}

function SelectTeam() {
  const location = useLocation();
  const data = useData(gql`
    query MainView {
      teams {
        id
      }
    }
  `);
  const teamIdNew = localStorage.getItem("visitedTeam") || data?.teams[0]?.id;

  if (
    matchPath({ path: "/", end: true }, location.pathname) &&
    data?.teams.map((t) => t.id).includes(teamIdNew)
  )
    return <Redirect to={`/${teamIdNew}${location.search}`} />;

  return <SelectTeamDialog />;
}

function Redirect({ to }) {
  const history = useHistory();

  useLayoutEffect(() => {
    history.replace(to);
  });

  return null;
}
